export const API_KEY_ENDPOINTS = {
    GET_ALL: '/api-keys/list',
    CREATE: '/api-keys/generate',
    DELETE: (id: string) => `/api-keys/${id}`,
} as const;
